import React, { useEffect, useRef, useState, } from 'react';
import HtmlParser from 'react-html-parser';
import ReCAPTCHA from 'react-google-recaptcha';
import Menu from '../main/Menu';

import { awaitDelay, getError, getLanguageObj, getResponse, isUndNullEmpNew, LoadingSection, sendMessageCloseCurrentWindow, settings, validateEmail, } from '../../helpers/UtilsHelper';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import { LoginService } from '../../services/login/LoginService';

const { app, icons, messages, labels, } = settings;
const { urls } = app?.backend;
const currentMethod = 'ForgotPassword - function';

export default function ForgotPassword({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const reCaptchaRef = useRef(ReCAPTCHA);
    const [formData, setFormData] = useState({ email: '' });
    const [errors, setErrors] = useState({ email: '' });
    const [process, setProcess] = useState({ showLoading: false, send: false, home: false, login: false });
    const isMount = useRef(true);
    //#endregion variables

    //#region methods
    const formDataValidate = ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'formDataValidate';
        let response = getResponse({ type: 0 });
        try {
            const errors_ = { email: '', }

            if (isUndNullEmpNew({ data: formData?.email, subMethod: currentMethod, })?.result) {
                errors_.email = messages?.thisFieldRequired?.[languageObj?.id];
                response = getResponse({ type: 1 });
            } else if (!validateEmail(formData?.email)) {
                errors_.email = messages?.youMustEnterValidEmail?.[languageObj?.id];
                response = getResponse({ type: 1 });
            }

            if (response?.isWarning) setErrors(prev => ({ ...prev, ...errors_ }));
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const forgotYourPassword = async ({
        e = {},
        subMethod = ''
    } = {}) => {
        const currentMethod = 'forgotYourPassword';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault();

            //#region variables
            //#endregion variables            

            setErrors(prev => ({ ...prev, email: '' }));

            //#region Form data validate
            response = formDataValidate({
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion Form data validate

            setProcess(prev => ({ ...prev, showLoading: true, send: true }));

            //#region forgot password
            const reCaptchaToken = await reCaptchaRef.current.executeAsync();
            reCaptchaRef.current.reset();

            response = await LoginService?.forgotPassword({
                email: formData.email,
                reCaptchaToken: reCaptchaToken,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion forgot password

            setFormData(prev => ({ ...prev, email: '' }));
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            setProcess(prev => ({ ...prev, showLoading: false, send: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const goTo = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'goTo';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault();
            setProcess(prev => ({ ...prev, showLoading: true, home: subMethod === 'btnHome', login: subMethod === 'btnLogin' }));
            await awaitDelay({ delayTime: settings?.timers?.oneSeconds });
            window.location.href = subMethod === 'btnHome' ? urls?.home : settings?.app?.backend?.urls?.login;
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, home: false, login: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const getData = async ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            // setFormData({ email: '' });
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
            await sendMessageCloseCurrentWindow({
                response: response,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line
    //#endregion methods

    return (
        <div>
            <Menu viewName={'home'} process={''} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.forgotYourPassword?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href={urls?.home}>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.forgotYourPassword?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className='col-12'>
                                {/* ✅ New Premium Callout for instructions (Rule 22) */}
                                {/* <div className='row mb-4'>
                                    <div className='col-12'>
                                        <div className='p-4 rounded-lg bg-light border-left border-primary shadow-sm'
                                            style={{ borderLeftWidth: '5px', backgroundColor: 'var(--color-primary-bg)' }}>
                                            <div className='d-flex align-items-center mb-2'>
                                                <i className={`${icons?.fasFa?.infoCircle} text-primary mr-2`} style={{ fontSize: '1.2rem' }} />
                                                <h5 className='mb-0 font-weight-bold text-dark'>{labels?.instructions?.[languageObj?.id] || 'Instrucciones'}</h5>
                                            </div>
                                            <div className='text-secondary mb-0'>
                                                <ul className='mb-0 pl-4'>
                                                    <li>{HtmlParser(messages?.forgotPasswordSubTitle01?.[languageObj?.id])}</li>
                                                    <li>{HtmlParser(messages?.forgotPasswordSubTitle02?.[languageObj?.id])}</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}

                                <div className='login-box-container'>

                                    <div className='card border-0 shadow-lg login-card' >
                                        <LoadingSection alt='loadingSection'
                                            className='overlay dark text-white'
                                            height={20}
                                            hidden={!process?.showLoading}
                                            width={20}
                                            languageId={languageObj?.id}
                                            subMethod={currentMethod} />

                                        {/* ✅ Premium Card Header (Rule 12) */}
                                        <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                            <div className='d-flex align-items-center'>
                                                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img alt='forgotYourPassword'
                                                        style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                        src={settings?.images?.passwordIcon02} />
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <h5 className='mb-0 font-weight-bold text-dark'>{labels?.forgotYourPassword?.[languageObj?.id]}</h5>
                                                    <div className='mt-1'>
                                                        <span className='badge badge-pill badge-primary px-2 py-1 text-uppercase' style={settings?.html?.badges?.micro}>
                                                            <i className={`${icons?.fasFa?.lock} mr-1`}></i> {labels?.security?.[languageObj?.id] || 'Security'}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <form onSubmit={(e) => forgotYourPassword({ e: e, subMethod: 'form - onSubmit' })} method='post'>

                                            {/*Body*/}
                                            <div className='card-body px-4 pt-2'>
                                                {/* <div className='text-center mb-4'>
                                                    <p className='text-muted small'>{labels?.enterYourEmail?.[languageObj?.id]}</p>
                                                </div> */}

                                                <div className='form-group'>
                                                    <label className='small font-weight-bold text-uppercase form-label-uppercase'>
                                                        {labels?.email?.[languageObj?.id]}
                                                    </label>
                                                    <div className='position-relative'>
                                                        <i className={`${icons?.fasFa?.envelope} position-absolute input-icon-left`} />
                                                        <input autoFocus
                                                            className='form-control border-0 shadow-sm form-input-icon'
                                                            onChange={(e) => setFormData({ ...formData, 'email': e.target.value })}
                                                            onFocus={() => setErrors(prev => ({ ...prev, email: '' }))}
                                                            placeholder={labels?.emailPlaceholder?.[languageObj?.id]}
                                                            title={labels?.email?.[languageObj?.id]}
                                                            autoComplete='email'
                                                            value={formData?.email} />
                                                    </div>
                                                    <div className='form-text mt-1 form-error-text'>{HtmlParser(errors?.email)}</div>
                                                </div>

                                                <div className='mt-0 pt-0'>
                                                    <div className='d-flex flex-column'>
                                                        {/* <div className='mb-2'>
                                                            <i className={`${icons?.fasFa?.userCheck} text-primary mr-2`} />
                                                            <a href='/registerNewUser' className='font-weight-bold text-dark btn-register-link'>
                                                                {labels?.registerNewMembership?.[languageObj?.id]}
                                                            </a>
                                                        </div> */}
                                                        {/* <div>
                                                            <i className={`${icons?.userClock} text-primary mr-2`} />
                                                            <a href='/registerStatus' className='font-weight-bold text-dark btn-register-link'>
                                                                {labels?.checkRegistrationStatus?.[languageObj?.id]}
                                                            </a>
                                                        </div> */}
                                                    </div>
                                                </div>
                                            </div>

                                            {/*Footer (Rule 3.2 Context B) */}
                                            <div className='card-footer border-top-0 pb-4 px-4 bg-white'>
                                                {/* <div className='d-flex flex-wrap justify-content-end w-100' style={{ gap: '2px' }}> */}
                                                <button className='btn btn-primary  btn-block shadow-sm font-weight-bold px-4 btn-primary'
                                                    style={{ borderRadius: '10px' }}
                                                    disabled={process?.showLoading}
                                                    data-title={labels?.send?.[languageObj?.id]}
                                                    type='submit' >
                                                    {!process?.send ? (
                                                        <i className={icons?.fasFa?.checkCircle} />
                                                    ) : (
                                                        <span className={`${settings?.react?.html?.spinner?.borderSm}`} aria-hidden='true'></span>
                                                    )} {labels?.send[languageObj?.id]}
                                                </button>
                                                <button className='btn btn-light btn-block border shadow-sm font-weight-bold px-4 text-secondary btn-general'
                                                    style={{ borderRadius: '10px' }}
                                                    disabled={process?.showLoading}
                                                    data-title={labels?.login?.[languageObj?.id]}
                                                    onClick={(e) => goTo({ e: e, subMethod: 'btnLogin' })}
                                                    type='button' >
                                                    {!process?.login ? (
                                                        <i className={icons?.fasFa?.powerOff} />
                                                    ) : (
                                                        <span className={`${settings?.react?.html?.spinner?.borderSm}`} aria-hidden='true'></span>
                                                    )} {labels?.login?.[languageObj?.id]}
                                                </button>
                                                {/* </div> */}
                                            </div>

                                        </form>

                                        <div className='px-4 pb-4 text-center border-top pt-3 login-register-section'>
                                            <p className='small text-muted mb-2'>{labels?.registerNewMembership?.[languageObj?.id]}</p>
                                            <div className='d-flex justify-content-center gap-2 flex-wrap'>
                                                {/* <a href='/registerNewUser' className='btn btn-outline-light btn-sm border text-dark mx-1 btn-register-link'> */}
                                                <a href='/registerNewUser' className='btn btn-light border shadow-sm  mx-1 font-weight-bold text-secondary'>
                                                    <i className={`${icons?.fasFa?.userCheck} mr-1 text-primary`} /> {labels?.createAccount?.[languageObj?.id]}
                                                </a>
                                                {/* <a href='/registerStatus' className='btn btn-outline-light btn-sm border text-dark mx-1 btn-register-link'> */}
                                                <a href='/registerStatus' className='btn btn-light border shadow-sm mx-1 font-weight-bold text-secondary'>
                                                    <i className={`${icons?.userClock} mr-1 text-warning`} /> {labels?.myStatus?.[languageObj?.id]}
                                                </a>
                                            </div>
                                        </div>

                                        {/* <div className='px-4 pb-3'> */}
                                        {/* <div style={{ display: 'g-recaptcha' }}> */}
                                        <ReCAPTCHA className='g-recaptcha'
                                            sitekey={settings?.app?.reCAPTCHA?.reCaptchaSiteKey}
                                            size='invisible'
                                            hl={languageObj?.id}
                                            ref={reCaptchaRef} />
                                        {/* </div> */}
                                    </div>

                                </div>

                                <div className='text-muted text-center mt-4'>
                                    <p className='mb-0'>
                                        <small className='recaptcha-notice'>
                                            {labels?.protectedByReCAPTCHA?.[languageObj?.id]} - <a target='_blank'
                                                href={settings?.app?.reCAPTCHA?.urlPrivaciConditions}
                                                className='text-primary'
                                                rel='noreferrer'>{labels?.privacyAndConditions?.[languageObj?.id]}
                                            </a>
                                        </small>
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}
            </div>
        </div>
    )
}